module.exports = __webpack_public_path__ + "media/images/landing/persons/jiri-lelek-1712e5df860eddf28fd3eaaa7c054252.jpg";